<template>
  <!-- 加入团队 -->
  <div>
    <el-card shadow="never" class="join_card">
      <div slot="header" class="clearfix">
        <div class="desciconLarge"></div>
        <span class="font18">{{info.title}}</span>
      </div>
      <div class="team_box">
        <el-input
          style="width: 50%"
          placeholder="请输入团体名称、团长姓名、团长手机号可加入"
          v-model="querySearch.condition"
          prefix-icon="el-icon-search"
        >
          <span slot="append">
            <span style="cursor: pointer;width: 100%" @click="getList()">搜索</span>
          </span>
        </el-input>
        <el-empty v-if="teamData.length == 0" description="暂无数据"></el-empty>
        <el-row :gutter="50" v-else type="flex" style="flex-wrap: wrap;">
          <el-col
            :xs="24"
            :sm="24"
            :md="24"
            :lg="12"
            :xl="12"
            v-for="(i,index) in teamData"
            :key="i+index"
          >
            <div class="team_card">
              <div class="team_card_img">
                <el-image :src="fileUrl + i.teamProFilePhoto" class="team_img">
                  <div slot="error">
                    <img src="@/assets/img/avatarTeam.png" class="team_img" />
                  </div>
                </el-image>
              </div>
              <div class="team_card_content">
                <div class="team_content_row">
                  <span class="team_content_row_name">团体名称</span>
                  {{i.teamName}}
                </div>
                <div class="team_content_row">
                  <span class="team_content_row_name">团长</span>
                  {{i.teamHeadName}}
                </div>
                <div class="team_content_row">
                  <span class="team_content_row_name">团长手机号</span>
                  {{i.teamHeadPhone}}
                </div>
                <div class="team_content_row">
                  <span class="team_content_row_name">所属单位/高校</span>
                  {{i.affiliatedUnit}}
                </div>
                <div class="team_content_row">
                  <span class="team_content_row_name">团员个数</span>
                  {{i.personnelNum}}
                </div>
                <el-button
                  type="primary"
                  size="small"
                  v-if="i.clientStatus == 2"
                  style="width: 130px;margin-top: 20px"
                  @click="applyJoin(i)"
                >申请加入</el-button>
                <el-button
                  type="primary"
                  size="small"
                  disabled
                  v-if="i.clientStatus == 1"
                  style="width: 130px;margin-top: 20px"
                >已申请</el-button>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </el-card>
  </div>
</template>
<script>
import { teamList,joinTeam } from "@/api/request";
export default {
  props: {
    info: {
      type: [Object, Array],
      default: () => {}
    }
  },
  data() {
    return {
      search: "",
      teamData: [],
      fileUrl: process.env.VUE_APP_FILE_API,
      querySearch: {
        pageNum: 1,
        pageSize: 100,
        queryType: 1,
        condition: ""
      }
    };
  },
  methods: {
    getList() {
      if (this.querySearch.condition != '') {
        this.querySearch.clientId = this.$store.getters.userInfo.clientId
        teamList(this.querySearch).then(res => {
          this.teamData = res.rows;
          this.teamData.map(item => {
            item.teamHeadPhone = this.encryptionPhoneNumber(item.teamHeadPhone)
          })
        });
      }
      
    },
    applyJoin(item) {
      if(this.$store.getters.userInfo.certStatus != 1) {
        this.$confirm("您还未进行身份认证，请先进行身份认证！", "温馨提示", {
          confirmButtonText: "前往个人个人资料",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.$emit('gotoPage', '1-2')
        })
      } else {
        this.$confirm("是否确认加入该团队，需团长同意确认?", "确认", {
          confirmButtonText: "加入",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          this.toApply(item)
        })
      }
    },
    toApply (item) {
      joinTeam({teamId: item.teamId,clientId: this.$store.getters.userInfo.clientId}).then(res=> {
        this.$message.success("申请成功");
        this.getList()
      })
    }
  }
};
</script>
<style scoped lang="scss">
.join_card {
  height: calc(100vh - 110px);
  overflow: hidden;
  overflow-y: scroll;
}
.team_card {
  display: flex;
  flex-flow: row nowrap;
  background: #f4f5f9;
  padding: 20px;
  margin: 25px 0;
  border-radius: 8px;
}
.team_card_img {
  // width: 200px;
  margin-right: 10%;
  text-align: center;
  margin-top: 20px;
  .team_img {
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }
}
.team_card_content {
  width: 80%;
}
.team_content_row {
  color: #666;
  font-size: 14px;
  display: flex;
  flex-flow: row nowrap;
  margin: 11px 0;
}
.team_content_row_name {
  display: block;
  width: 100px;
  color: #111111;
  font-weight: 500;
}
</style>